var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('div',[_c('ckeditor',{attrs:{"config":_vm.editorConfig},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }